module.exports = __webpack_public_path__ + "img/sp-lgo-2.1512a22e.jpg";